import { JqlClause, JqlQuery } from '@qality/common-model';
import { StringUtils } from '@qality/common-utils';

class JqlClauseBuilder implements JqlClause {
  clause: string;
  parent: JqlQuery;

  constructor(parent: JqlQuery) {
    this.clause = 'issuetype = "QAlity Test" ';
    this.parent = parent;
  }

  endWhere(): JqlQuery {
    return this.parent;
  }

  withProjects(projectKeys: Array<string>): this {
    if (projectKeys?.length) {
      this.clause += `AND project in (`;
      this.clause += projectKeys.map((key) => `"${key}"`).join(', ');
      this.clause += ') ';
    }
    return this;
  }

  withText(text: string): this {
    const textWithoutSpecialCharacters =
      StringUtils.getStringWithoutSpecialCharacters(text).trim();

    const textWithWildCard = StringUtils.addWildCardToText(
      textWithoutSpecialCharacters
    );

    if (textWithoutSpecialCharacters !== '') {
      this.clause += `AND (text ~ "${textWithoutSpecialCharacters}" OR text ~ "${textWithWildCard}") `;
    }
    return this;
  }

  withKeys(keys: Array<string>): this {
    if (keys.length !== 0) {
      this.clause += `AND key in (`;
      this.clause += keys.map((key) => `"${key}"`).join(' , ');
      this.clause += ` ) `;
    }
    return this;
  }

  withStatuses(statusNames: Array<string>): this {
    if (statusNames.length !== 0) {
      this.clause += `AND status in (`;
      this.clause += statusNames.map((name) => `"${name}"`).join(', ');
      this.clause += `) `;
    }
    return this;
  }

  withIssueIds(issueIds: Array<number>): this {
    if (issueIds.length !== 0) {
      this.clause += `AND id in (`;
      this.clause += issueIds.map((id) => `${id}`).join(', ');
      this.clause += `) `;
    }
    return this;
  }

  build(): string {
    return this.clause;
  }
}

export default JqlClauseBuilder;
